// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { AgentOutputTurnFragmentFileBuf } from '../conversation/agent-output-turn-fragment-file-buf.js';
import { AgentOutputTurnFragmentFileDetailsBuf } from '../conversation/agent-output-turn-fragment-file-details-buf.js';


export class AgentOutputTurnFragmentBuf {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):AgentOutputTurnFragmentBuf {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsAgentOutputTurnFragmentBuf(bb:flatbuffers.ByteBuffer, obj?:AgentOutputTurnFragmentBuf):AgentOutputTurnFragmentBuf {
  return (obj || new AgentOutputTurnFragmentBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsAgentOutputTurnFragmentBuf(bb:flatbuffers.ByteBuffer, obj?:AgentOutputTurnFragmentBuf):AgentOutputTurnFragmentBuf {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new AgentOutputTurnFragmentBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

text():string|null
text(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
text(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

fileRef(obj?:AgentOutputTurnFragmentFileBuf):AgentOutputTurnFragmentFileBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new AgentOutputTurnFragmentFileBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileDetailsRef(obj?:AgentOutputTurnFragmentFileDetailsBuf):AgentOutputTurnFragmentFileDetailsBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? (obj || new AgentOutputTurnFragmentFileDetailsBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

fileSnippetRef():string|null
fileSnippetRef(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
fileSnippetRef(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

sqlCommand():string|null
sqlCommand(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
sqlCommand(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

sqlOutputJson():string|null
sqlOutputJson(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
sqlOutputJson(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

static startAgentOutputTurnFragmentBuf(builder:flatbuffers.Builder) {
  builder.startObject(7);
}

static addText(builder:flatbuffers.Builder, textOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, textOffset, 0);
}

static addFileRef(builder:flatbuffers.Builder, fileRefOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, fileRefOffset, 0);
}

static addFileDetailsRef(builder:flatbuffers.Builder, fileDetailsRefOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, fileDetailsRefOffset, 0);
}

static addFileSnippetRef(builder:flatbuffers.Builder, fileSnippetRefOffset:flatbuffers.Offset) {
  builder.addFieldOffset(4, fileSnippetRefOffset, 0);
}

static addSqlCommand(builder:flatbuffers.Builder, sqlCommandOffset:flatbuffers.Offset) {
  builder.addFieldOffset(5, sqlCommandOffset, 0);
}

static addSqlOutputJson(builder:flatbuffers.Builder, sqlOutputJsonOffset:flatbuffers.Offset) {
  builder.addFieldOffset(6, sqlOutputJsonOffset, 0);
}

static endAgentOutputTurnFragmentBuf(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

}
